import { selectBasketCheckPriceItem, selectBasketItem } from '../basketSlice'
import { useHistory, useParams } from 'react-router-dom'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import { useReduxSelector } from 'store'
import React from 'react'

const Equipment: React.FC = () => {
  const { id: identifier } = useParams<{ id: string }>()
  const basketItem = useReduxSelector(state => selectBasketItem(state, identifier))
  const checkPrice = useReduxSelector(state => selectBasketCheckPriceItem(state, identifier))
  const selectedEquipment = (Object.values(basketItem.equipment || {}) as shop.EquipmentItem[]).filter((e) => e.quantity > 0)

  const { push } = useHistory()
  const { t } = useTranslation('basket')

  if (!checkPrice?.equipment) {
    return null
  }

  return (
    <div className='orderInfoButton'>
      <div className='title group'>
        <div>
          <span>{t('equipment')}</span>
        </div>
        {selectedEquipment.length > 0 && <span
          className='orderInfo__add'
          onClick={() => {
            push(`/order/${identifier}/equipment/${checkPrice.equipmentCategoryId}`)
          }}>
          + {t('add')}
        </span>}
      </div>

      <div className='orderInfo__items'>
        {selectedEquipment.length > 0
          ? selectedEquipment.map(({ id, categoryId, name, icon, quantity, unitMonthlyGrossPrice }) => {
            return <div
              key={id}
              className={`orderInfo__item${quantity > 0 ? ' --selected' : ''}`}
              onClick={() => {
                push(`/order/${identifier}/equipment/${checkPrice.equipmentCategoryId}/${categoryId}`)
              }}>
              <div className='orderInfo__item__icon'>
                <i className={`icon icon--${icon}-bold`} />
              </div>
              <div className='orderInfo__item__content'>
                <div className='orderInfo__item__title'>{quantity} x {name}</div>
                <div className='orderInfo__item__scope'>{quantity} x {displayPrice(unitMonthlyGrossPrice)} / {t('month')}</div>
              </div>
              <ArrowBtn
                text={t('change')}
                showArrow={false}
                className='--secondary'
                action={() => { }}
              />
            </div>
          })
          : (checkPrice.equipment as shop.EquipmentItem[]).map(({ id, categoryId, categoryName, icon, unitMonthlyGrossPrice }) => {
            return <div
              key={id}
              className='orderInfo__item'
              onClick={() => {
                push(`/order/${identifier}/equipment/${checkPrice.equipmentCategoryId}/${categoryId}`)
              }}>
              <div className='orderInfo__item__icon'>
                <i className={`icon icon--${icon}-bold`} />
              </div>
              <div className='orderInfo__item__content'>
                <div className='orderInfo__item__title'>{categoryName}</div>
                <div className='orderInfo__item__scope'>{t('from')}: {displayPrice(unitMonthlyGrossPrice)} / {t('unit')}</div>
              </div>
              <ArrowBtn
                text={t('add')}
                showArrow={false}
                className='--secondary'
                action={() => { }}
              />
            </div>
          })}
      </div>
    </div>
  )
}

export default Equipment